import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import { BASE_URL } from '../Config/Base';

const CorpCareerMain = () => {

  useEffect(()=>{
    getCorpCareers()
  },[])
  function getCorpCareers(){
    const token = JSON.parse(localStorage.getItem('usertoken'));
   
   
   
    fetch(`${BASE_URL}/Kdpcorp/GetCorpCareers`, {
      method:'GET',
   
    headers : {
   
      "Content-type": "application/json",
   
      "Accept": "application/json",
   
      "Authorization": "Bearer " +`${token}`,
   
      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },
   
   
   })
   
   .then(response => response.json())
   
   
   .then(data => {
   console.log("Section",data)
   
   localStorage.setItem("CorpContentCareersData", JSON.stringify(data));
   });

   
   }
  return (
    <>
    
    <div className='Corp-addmainPiccare' >
    <div className='Corp-addmain' id="Corppicture">

    <div className="holder">


    <div className="dot dot5 con ">
      
      </div>
  
      {/* <div className="dot dot6 Img ">
        
      </div>  */}
  

   
    <ul id='Corp-sectionMain' className="titles" >

  
   

    {/* <li  id="Corp-touchMainC">
   
    <nav id="Corp-section-nav"> */}

<label for="Corp-touchC" id="corpsectionlable">

  {/* <i  onClick={CorpopensectionC}></i>
  <i  onClick={CorpclosesectionC}></i> */}
  &nbsp;<li id ="Corp-sectionC-head" className="title5 title-animate"><Link to="/CorpContentCareers" id="Corplifetext">Content</Link></li>
  </label>               
<input type="checkbox" id="Corp-touchC" /> 

<ul class="Corp-slide" id="Corp-slideC">

<ul className='CorpList'>

    {/* <li><Link to="/CorpGBContent"><p>Content</p></Link></li>
    <li><Link to="/CorpGBImages"><p>Images</p></Link></li> */}

</ul>
</ul>

{/* </nav> 

</li> */}




    </ul>




    {/* </div>  */}

    </div>


  
    </div>


    
     </div>

    </>
  )
}

export default CorpCareerMain